/* eslint-disable consistent-return */
/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import cookies from 'react-cookies';
import { Route, Redirect } from 'react-router-dom';
import api from '../services/api';

interface MerchantDTO {
  stone_code: string;
  affiliation_key: string;
  legal_name: string;
  fantasy_name: string;
  document: string;
  on_registry: string;
  address_address_type: string;
  address_city: string;
  address_neighborhood: string;
  address_state_code: string;
  address_street_name: string;
  address_street_number: number;
  address_complement: number;
  address_postal_code: number;
}
interface TermDTO {
  id: number;
  template_reference: string;
  document_reference: string;
  pdf_reference: string;
  merchant_data: MerchantDTO;
  acceptance_data: string;
  merchant_id: number;
  status: string;
  created_at: string;
  updated_at: string;
}

const PrivateRoute = ({ component, ...rest }: any) => {
  const [resq, setReq] = React.useState(0);
  const [auth, setAuth] = React.useState(0);
  async function searchTerm(
    dataInSearch: Array<TermDTO> | undefined,
    statusInSearch: number,
  ): Promise<boolean> {
    if (
      cookies.load('external_stone_codes') &&
      cookies.load('external_tags') &&
      dataInSearch !== undefined
    ) {
      // Seta como 1 indicando que está logado
      setAuth(1);
      if (dataInSearch?.length === 0) {
        localStorage.removeItem('qtdTerm');
        setAuth(1);
        setReq(2);
        return true;
      }
      if (dataInSearch) {
        localStorage.setItem('qtdTerm', dataInSearch.length.toString());
        // Caso dê erro manda pra notfound
        if (statusInSearch !== 200) {
          setAuth(0);
          setReq(3);
          return false;
        }
        // Caso a consulta dos termos retorne vazio manda pra tela de TermOK
        if (dataInSearch?.length === 0) {
          setReq(2);
          return false;
        }
        // Caso não, manda para a página para mostrar o termo e aceitar
        localStorage.setItem('idpdf', `${dataInSearch[0].id}`);
        localStorage.setItem(
          'pdf',
          `${
            process.env.REACT_APP_API_REQUEST_ENDPOINT
          }/v0/gps/merchants/${cookies.load(
            'external_stone_codes',
          )}/terms-of-service/${dataInSearch[0].id}.pdf`,
        );
        setReq(1);
        return true;
      }
    } else {
      setReq(3); // Tela de NotFound
      setAuth(0); // Tela de carregamento
      return false;
    }
    return false;
  }

  React.useEffect(() => {
    api
      .get(
        `/v0/gps/merchants/${cookies.load(
          'external_stone_codes',
        )}/terms-of-service?status=PE`,
        {
          headers: {
            Authorization: `Bearer ${cookies.load('external_token')}`,
          },
        },
      )
      .then(response => {
        searchTerm(response.data, response.status);
      })
      .catch(() => {
        searchTerm(undefined, 401);
      });
  }, []);

  const routeComponent = (props: any) => {
    if (auth && resq === 2 && !localStorage.getItem('qtdTerm')) {
      return React.createElement(component, props);
    }
    let routeVar;
    switch (resq) {
      case 0:
        routeVar = '/';
        break;
      case 1:
        routeVar = '/term';
        break;
      case 2:
        routeVar = '/termok';
        break;
      case 3:
        routeVar = '/notconnected';
        break;
      default:
        routeVar = '/notfound';
        break;
    }
    return <Redirect to={{ pathname: routeVar }} />;
  };
  return <Route {...rest} render={routeComponent} />;
};

export default PrivateRoute;
